import React from "react";
import BulkWeaponAssignment from "../components/weapons/BulkWeaponAssignment";
import { BreakawayWeaponAssignmentInline } from "../components/weapons/BreakawayWeaponAssignmentInline";
import { BreakawayWeaponStatsFooter } from "../components/weapons/BreakawayWeaponStatsFooter";
import { BreakawayHullsBanner } from "../components/weapons/BreakawayHullsBanner";
import { useAppSelector } from "../../../store/hooks";
import { selectIsBreakaway } from "../../../store/selectors/breakawayHullSelectors";

const WeaponsStep: React.FC = () => {
  const isBreakaway = useAppSelector(selectIsBreakaway);
  const breakawayHull = useAppSelector((state) => state.breakawayHull);
  
  // Check if ship has breakaway hulls
  const hasBreakawayHulls = isBreakaway || breakawayHull?.isBreakaway;

  return (
    <div className="w-full pb-32">
      <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
        Weapons & Defensive Systems
      </h2>

      {/* Breakaway Hulls Banner */}
      {hasBreakawayHulls && <BreakawayHullsBanner />}

      {/* Unified Weapons & Defensive Systems Interface */}
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
        <div className="p-4">
          {hasBreakawayHulls ? (
            <BreakawayWeaponAssignmentInline />
          ) : (
            <BulkWeaponAssignment />
          )}
        </div>
      </div>

      {/* Breakaway Weapon Stats Footer */}
      {hasBreakawayHulls && <BreakawayWeaponStatsFooter />}
    </div>
  );
};

export default WeaponsStep;